import React from "react";
import { useHistory } from "react-router";
import LoginPage from "../../../welcome/LoginPage";
import PathHelper from "../../PathHelper";

export default function MarketLoginPage() {
	const history = useHistory();

	// ------------------------------------- METHODS -------------------------------------
	const user = {
		name: "Johnny C.",
		publicKey: "acmeMFYwEAYHKoZIzj0CAQYFK4EEAA",
		avatar: "marketUserAvatar",
	};

	const onContinue = () => {
		const { name, publicKey, avatar } = user;

		let params = [];
		if (name) params.push(`name=${name}`);
		if (publicKey) params.push(`publicKey=${publicKey}`);
		if (avatar) params.push(`avatar=${avatar}`);

		history.push({
			pathname: PathHelper.getPath("market", ""),
			search: `?${params.join("&")}`,
		});
	};

	return <LoginPage onComplete={onContinue} />;
}
